/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
// import { ICellRendererParams } from '@ag-grid-community/core';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import {
    Popper,
    Grow,
    Paper,
    ClickAwayListener,
    MenuList,
    MenuItem,
    IconButton,
    Avatar,
    Tooltip,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
// import { styles } from '../../home/styles';
import { client } from '../..';
import { AddUserMatterAccessActivity } from '../MatterSummaryPageX';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import { WriteOffWipDialog } from '../dialogs/WriteOffWipDialog';
import { WriteOffDebtorsDialog } from '../dialogs/WriteOffDebtorsDialog';
import { BillTheMatterDialog } from '../dialogs/BillTheMatterDialog';
import { TransferTustToPayInvoiceDialog } from '../dialogs/TransferTustToPayInvoiceDialog';
import { ArchiveMatterDialog } from '../dialogs/ArchiveMatterDialog';
import { CloseMatterDialog } from '../dialogs/CloseMatterDialog';
import { MatterDetailsQuery, MatterDetailsQueryParameters, MatterDetailsResponse, MatterDetails } from '../MatterSummaryRepository';
import DoneIcon from '@material-ui/icons/Done';
import { CurrencyOptionData, fetchAppUserData, fetchCurrencyData } from '../../matterManagement/MatterManagementRepository';
import { showNotification } from '../../App';
import { RvLoader } from '../../components/Loader';
import { TasksSummaryFormDialog } from '../../tasksSummary/dialog/TasksSummaryFormDialog';
import { AppUserData } from '../../enquirySummary/EnquirySummaryRepository';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { PriorityData, retrievePriorityData } from '../../tasksSummary/TasksSummaryRepository';
import { UploadDocumentDialog } from '../dialogs/UploadDocumentDialog';
import { MatterFollowUpDialog } from '../dialogs/MatterFollowUpDialog';
import ArchiveOutlinedIcon from '@material-ui/icons/ArchiveOutlined';
import { mainTheme } from '../../Theme';
import CancelPresentationOutlinedIcon from '@material-ui/icons/CancelPresentationOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import PlaylistAddOutlinedIcon from '@material-ui/icons/PlaylistAddOutlined';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import TollOutlinedIcon from '@material-ui/icons/TollOutlined';
import LocationSearchingOutlinedIcon from '@material-ui/icons/LocationSearchingOutlined';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import CastOutlinedIcon from '@material-ui/icons/CastOutlined';
import { useMatterSummaryContext } from '../MatterSummaryContextProvider';
import { useTenant } from '../../hooks/useTenant';
import EditIcon from '@material-ui/icons/Edit';
import { ImportanceLevelDrawer } from '../drawers/ImportanceLevelDrawer';
import { retrieveQueryDataAsync } from '../../helpers/commonHelper';
import { PublishMatterDialog } from '../dialogs/PublishMatterDialog';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { MatterSendEmailDialog } from '../dialogs/MatterSendEmailDialog';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            // loaderWrapper below is position:absolute with top/bottom/left/right:0 - without
            // this, it escapes to the nearest positioned ancestor (RecordDetailLayout.tsx's
            // banner, position:relative) and centers across the whole header bar instead of
            // just this button.
            position: 'relative',
        },
        doneIcon: {
            marginRight: '10px',
        },
        loaderWrapper: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        icon: {
            marginRight: '10px',
            color: mainTheme.BrandColors.TemplatePrimary
        },
    })
);

export enum MatterTaskActionEnum {
    BillMatter = 1,
    WriteOffUnbilledFees,
    TransferTrustToPayInvoice,
    WriteOffDebtors,
    CloseMatter,
    ArchiveMatter,
    ViewMatter,
    CreateTask,
    EmailPersonActing,
    EmailPersonResponsible,
    UploadDocument,
    MatterFollowUpAction,
    MatterForecasts,
    SmokeballViewMatter,
    ImportanceLevel,
    PublishMatter,
    SendEmail,
}

export interface CurrencyDetails {
    currencySymbol: string;
    currency: string;
}

interface MatterTaskActionProps /* extends ICellRendererParams,*/ /*WithStyles<typeof styles>*/ {
    // tslint:disable-next-line: no-any
    data?: any;
    matterId: number;
    hideViewMatter?: boolean;
}

type MatterTaskDialogState = {
    isBillMatterOpen: boolean;
    isWriteOffUnbilledFeesOpen: boolean;
    isTransferTrustToPayInvoiceOpen: boolean;
    isWriteOffDebtorsOpen: boolean;
    isCloseMatterOpen: boolean;
    isArchiveMatterOpen: boolean;
    isCreateTaskOpen: boolean;
    isUploadDocumentOpen: boolean;
    isMatterFollowUpOpen: boolean;
    isImportanceLevelOpen: boolean;
    isPublishMatterOpen: boolean;
    isSendEmailOpen: boolean;
};

interface MatterTaskActionState extends MatterTaskDialogState {
    loggedInUser: IAutoCompleteItem | null;
    defaultPriority: IAutoCompleteItem | null;
}

// tslint:disable-next-line: no-any
export const MatterTaskAction: React.FC<MatterTaskActionProps> = ( props ) => {
    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    
    const tenantQuery = useTenant();

    const { onMaterForcastFormOpen } = useMatterSummaryContext();

    const [currencyData, setCurrencyData] = useState<CurrencyDetails>();
    const [matterData, setMatterData] = useState<MatterDetails>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [state, setState] = useState<MatterTaskActionState>({
        isBillMatterOpen: false,
        isWriteOffUnbilledFeesOpen: false,
        isTransferTrustToPayInvoiceOpen: false,
        isWriteOffDebtorsOpen: false,
        isCloseMatterOpen: false,
        isArchiveMatterOpen: false,
        isCreateTaskOpen: false,
        isUploadDocumentOpen: false,
        isMatterFollowUpOpen: false,
        isImportanceLevelOpen: false,
        isPublishMatterOpen: false,
        isSendEmailOpen: false,
        loggedInUser: null,
        defaultPriority: null,
    });

    const matterId: number = props.matterId 
        ? props.matterId 
        : (props.data && props.data.id) ? props.data.id : 0;

    const fetchCurrencyDetails = () => {
        if (currencyData === undefined) {
            fetchCurrencyData(false,
                              (data: CurrencyOptionData) => {
                                handleCurrencyFetch(data);
                               }, 
                              (reason) => {
                                    showNotification('Failed to Fetch App User Settings', reason, 'error'); 
                               });
        }
    };

    const handleCurrencyFetch = (data: CurrencyOptionData) => {
        if (data && !data.loading && data.options) {
            if (data.options.currencySymbol && data.options.localCurrency) {
                setCurrencyData({
                    currency: data.options.localCurrency.currency,
                    currencySymbol: data.options.currencySymbol.symbol
                });
            }
        }
    };

    const fetchMatterDetails = async () => {
        
        const data = await retrieveQueryDataAsync<MatterDetailsQueryParameters, MatterDetailsResponse>({
            params: {
                matterId: matterId
            },
            query: MatterDetailsQuery,
            refreshData: true,
        });
        
        if (data && data.matter) {
            setMatterData(data.matter);
            setIsLoading(false);
        }
        
        // fetchMatterDetailsData(true, // This should always be a new request.
        //                        matterId,
        //                        (data: MatterData) => {
        //                             handleMatterDataFetch(data);
        //                        }, 
        //                        (reason) => {
        //                             showNotification('Failed to Fetch App User Settings', reason, 'error'); 
        //                        });
        
    };

    // const handleMatterDataFetch = (data: MatterData) => {
    //     if (data && !data.loading && data.matter) {
    //         if (data.matter) {
    //             setMatterData(data.matter);

    //             setIsLoading(false);
    //         }
    //     }
    // };

    const fetchUser = () => {
        fetchAppUserData(
            false,
            (data: AppUserData) => handleUserDataFetch(data),
            // tslint:disable-next-line: no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const handleUserDataFetch = (data: AppUserData) => {
        setState((prevState) => {
            return {
                ...prevState,
                loggedInUser: { label: data.appUser.name, value: data.appUser.userId, isInternal: data.appUser.isInternal },
                isLoading: false
            };
        });
    };

    const fetchPriority = () => {
        retrievePriorityData(
            false,
            // tslint:disable-next-line: no-console
            (data) => handlePriorityDataFetch(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
                showNotification(null, reason, 'error');
            }
        );
    };

    const handlePriorityDataFetch = (data: PriorityData) => {
        // set the priority default data
        const priorityData = data.lookup.priority.filter(value => {
            return value.description === 'No Priority';
        });

        if (priorityData && priorityData.length > 0) {
            setState((prevState) => {
                return {
                    ...prevState,
                    defaultPriority: { label: priorityData[0].description, value: priorityData[0].guidId },
                    isLoading: false
                };
            });
        }        
    };

    const handleToggle = useCallback(() => {
        // tslint:disable-next-line: no-shadowed-variable
        setOpen((prevOpen) => !prevOpen);
        setIsLoading(true);
        fetchMatterDetails();
        // Deferred from a mount-time useEffect - this component mounts once per visible row
        // when used as an ag-grid cellRendererFramework (MatterSummaryColumns.tsx,
        // ColumnConfig.tsx, InvoiceSummaryColumns.tsx, MatterSummaryDrillDownColumns.tsx) as
        // well as once in the Matter Details header, so firing these on mount meant every row
        // queried currency/user/priority data whether or not its menu was ever opened. All
        // three already use fetchPolicy:'cache-first' (refreshData=false), and are only
        // consumed by the dialogs opened from menu items below, which can't be reached without
        // opening this menu first - safe to fetch lazily here instead.
        fetchCurrencyDetails();
        fetchUser();
        fetchPriority();
    }, []);


    const archorEvent = (event: React.MouseEvent<EventTarget>) => {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)) {
            return;
        }
    };

    const handleClickMenu = (menu: MatterTaskActionEnum) => (event: React.MouseEvent<EventTarget>) => {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        switch (menu) {
            case MatterTaskActionEnum.BillMatter : {
                setOpen(false);
                onBillTheMatterOpen(event);
                break;
            }
            case MatterTaskActionEnum.WriteOffUnbilledFees : {
                setOpen(false);
                onWriteOffUnbilledFeesOpen(event);
                break;
            }
            case MatterTaskActionEnum.TransferTrustToPayInvoice : {
                setOpen(false);
                onTransferTrustToPayInvoiceOpen(event);
                break;
            }
            case MatterTaskActionEnum.WriteOffDebtors: {
                setOpen(false);
                onWriteOffDebtorsOpen(event);
                break;
            }
            case MatterTaskActionEnum.CloseMatter: {
                setOpen(false);
                onCloseMatterOpen(event);
                break;
            }
            case MatterTaskActionEnum.ArchiveMatter: {
                setOpen(false);
                onArchiveMatterOpen(event);
                break;
            }
            case MatterTaskActionEnum.CreateTask: {
                setOpen(false);
                onCreateMatterTaskOpen(event);
                break;
            }
            case MatterTaskActionEnum.UploadDocument: {
                setOpen(false);
                onUploadDocumentOpen(event);
                break;
            }
            case MatterTaskActionEnum.MatterFollowUpAction: {
                setOpen(false);
                onMatterFollowUpOpen(event);
                break;
            }
            case MatterTaskActionEnum.MatterForecasts: {
                setOpen(false);
                onMatterForecastsOpen(matterId, matterData!.matterGuid, event);
                break;
            }
            case MatterTaskActionEnum.SmokeballViewMatter: {
                setOpen(false);
                window.open(tenantQuery.data?.tenant.smokeballAccessUrl?.replace('{0}', matterData?.matterGuid || '') || '', '_blank');
                break
            }
            case MatterTaskActionEnum.ImportanceLevel: {
                setOpen(false);
                onImportanceLevelOpen(event);
                break;
            }
            case MatterTaskActionEnum.PublishMatter: {
                setOpen(false);
                onPublishMatter(event);
                break;
            }
            case MatterTaskActionEnum.SendEmail: {
                setOpen(false);
                onSendEmail(event);
                break;
            }
            default: {
                setOpen(false);
                break;
            }
        }
    };

    const onBillTheMatterOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isBillMatterOpen: true
        });
    };

    const onWriteOffUnbilledFeesOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isWriteOffUnbilledFeesOpen: true
        });
    };

    const onTransferTrustToPayInvoiceOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isTransferTrustToPayInvoiceOpen: true
        });
    };

    const onWriteOffDebtorsOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isWriteOffDebtorsOpen: true
        });
    };
    
    const onCloseMatterOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isCloseMatterOpen: true
        });
    };    

    const onArchiveMatterOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isArchiveMatterOpen: true
        });
    };    
    
    const onCreateMatterTaskOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isCreateTaskOpen: true
        });
    }; 

    const onUploadDocumentOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState({
            ...state,
            isUploadDocumentOpen: true
        });
    };
    
    const onMatterFollowUpOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        setState((prevState) => {
            return {
                ...prevState,
                isMatterFollowUpOpen: true
            };
        });
    };
    // tslint:disable-next-line: no-shadowed-variable
    const onMatterForecastsOpen = (matterId: number, matterGuid: string, event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        onMaterForcastFormOpen(matterId, matterGuid);

        // setState((prevState) => {
        //     return {
        //         ...prevState,
        //         isMatterForecastsOpen: true
        //     };
        // });
    };
    
    const onImportanceLevelOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);
        setState((prevState) => {
            return {
                ...prevState,
                isImportanceLevelOpen: true
            };
        });
    };
    
    const onPublishMatter = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);
        setState((prevState) => {
            return {
                ...prevState,     
                isPublishMatterOpen: true
            };
        });
                  
    };

    const onSendEmail = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);
        setState((prevState) => {
            return {
                ...prevState,     
                isSendEmailOpen: true
            };
        });
    };

    // const onEmailPersonActing = (event: React.MouseEvent<EventTarget>) => {
    //     archorEvent(event);
    //     setOpen(false);

    //     var mail = document.createElement('a');
    //     // tslint:disable-next-line: max-line-length
    //     mail.href = `mailto:${matterData?.actingEmail}?subject=RE ${matterData?.client} - ${matterData?.description} (${matterData?.fileNumber})`;
    //     mail.click();
    // };

    // const onEmailPersonResponsible = (event: React.MouseEvent<EventTarget>) => {
    //     archorEvent(event);
    //     setOpen(false);

    //     var mail = document.createElement('a');
        // tslint:disable-next-line: max-line-length
    //     mail.href = `mailto:${matterData?.responsibleEmail}?subject=RE ${matterData?.client} - ${matterData?.description} (${matterData?.fileNumber})`;
    //     mail.click();
    // };

    const onDialogClose = () => {
        setOpen(false);

        setState({
            ...state,
            isBillMatterOpen: false,
            isWriteOffUnbilledFeesOpen: false,
            isTransferTrustToPayInvoiceOpen: false,
            isWriteOffDebtorsOpen: false,
            isCloseMatterOpen: false,
            isArchiveMatterOpen: false,
            isCreateTaskOpen: false,
            isUploadDocumentOpen: false,
            isMatterFollowUpOpen: false,
            isImportanceLevelOpen: false,
            isPublishMatterOpen: false,
            isSendEmailOpen: false,
        });
    };

    const onMatterDetailOpen = (event: React.MouseEvent<EventTarget>) => {
        archorEvent(event);
        setOpen(false);

        client.mutate<{ addUserMatterAccessActivity: boolean }>({
            mutation: AddUserMatterAccessActivity,
            variables: {
                matterId: matterId
            }
        }).then((results) => {
            if (results.data?.addUserMatterAccessActivity === false) {
                // tslint:disable-next-line:no-console
                console.log('AddUserMatterAccessActivity mutation failed');
            } 
        });      

        sessionStorage.setItem('typeOfView', 'noback');

        // TODO: We need state of Matter Summary to be passed
        var href = history.createHref({
            pathname: '/matterDetail/' + matterId,
            key: 'matterManagement',
            state: {
                matterManagementState: 'false',
            }
        });

        window.open(href, '_blank');
    };

    const handleClose = (event: React.MouseEvent<EventTarget>) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
        // tslint:disable-next-line: align
    }, [open]);

    // tslint:disable-next-line: no-shadowed-variable
    const getMatterTaskActions = (matterId: number) => {
        if (matterData && currencyData) {
            const unBilledFees = matterData.financials ? matterData.financials.unbilledTimeAndFees : 0;
            const unbilledDisbursements =  matterData.financials ? matterData.financials.unbilledDisbursements : 0;
            const outstandingDebtors =  matterData.financials ? matterData.financials.debtors : 0;
            const currentTrustBalance = matterData.financials ? matterData.financials.trustBalance : 0;
            const billedFees = matterData.financials ? matterData.financials.billedTimeAndFees : 0;
            const feeEstimate = matterData.financials ? matterData.financials.feeEstimate : 0;
            const percentageEstimate = matterData.financials ? matterData.financials.percentageEstimate : 0;
            const pendingWriteOffFeesAmountInBillMatterTask = matterData.financials 
                                                                ? matterData.actions.pendingWriteOffFeesAmountInBillMatterTask 
                                                                : 0;
            const pendingWriteOffFeesAmountInWriteOffWipTask = matterData.financials 
                                                                ? matterData.actions.pendingWriteOffFeesAmountInWriteOffWipTask 
                                                                : 0;
            const pendingWriteOffDisbAmountInBillMatterTask = matterData.financials 
                                                                ? matterData.actions.pendingWriteOffDisbAmountInBillMatterTask 
                                                                : 0;
            const pendingWriteOffDisbAmountInWriteOffWipTask = matterData.financials 
                                                                ? matterData.actions.pendingWriteOffDisbAmountInWriteOffWipTask  
                                                                : 0;

            const matterTitle = `${matterData.description}`;

            return (
                <React.Fragment>
                    {state.isImportanceLevelOpen && (
                        <ImportanceLevelDrawer 
                            open={state.isImportanceLevelOpen}
                            onClose={onDialogClose}
                            matterDetails={matterData}
                            currencySymbol={currencyData.currencySymbol}
                            sourceSystem={tenantQuery.data?.tenant.sourceSystem}
                            currentUser={{
                                name: state.loggedInUser?.label,
                                userId: state.loggedInUser?.value,
                                isInternal: state.loggedInUser?.isInternal || false
                            }}
                        />
                    )}
                    
                    {state.isBillMatterOpen && (
                        <BillTheMatterDialog 
                            currencyDetails={currencyData}
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterTitle}
                            client={matterData.client}
                            onDialogClose={onDialogClose}
                            unBilledFees={unBilledFees}
                            unbilledDisbursements={unbilledDisbursements}
                            outstandingDebtors={outstandingDebtors}
                            currentTrustBalance={currentTrustBalance}
                            billedFees={billedFees}
                            feeEstimate={feeEstimate}
                            percentageEstimate={percentageEstimate}
                            pendingWriteOffFeesAmount={pendingWriteOffFeesAmountInWriteOffWipTask}
                            pendingWriteOffDisbAmount={pendingWriteOffDisbAmountInWriteOffWipTask}
                            loggedInUser={state.loggedInUser}
                            defaultPriority={state.defaultPriority}
                            formAction={'create'}
                        />
                    )}
                    
                    {state.isWriteOffUnbilledFeesOpen && (
                        <WriteOffWipDialog 
                            currencyDetails={currencyData}
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterTitle}
                            client={matterData.client}
                            onDialogClose={onDialogClose}
                            unBilledFees={unBilledFees}
                            unbilledDisbursements={unbilledDisbursements}
                            outstandingDebtors={outstandingDebtors}
                            billedFees={billedFees}
                            canClose={matterData.actions.canCloseMatter}
                            pendingWriteOffFeesAmount={pendingWriteOffFeesAmountInBillMatterTask}
                            pendingWriteOffDisbAmount={pendingWriteOffDisbAmountInBillMatterTask}
                            loggedInUser={state.loggedInUser}
                            defaultPriority={state.defaultPriority}
                            formAction={'create'}
                        />
                    )}
                    
                    {state.isWriteOffDebtorsOpen && (
                        <WriteOffDebtorsDialog 
                            currencyDetails={currencyData}
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterTitle}
                            client={matterData.client}
                            onDialogClose={onDialogClose}
                            unBilledFees={unBilledFees}
                            unbilledDisbursements={unbilledDisbursements}
                            outstandingDebtors={outstandingDebtors}
                            billedFees={billedFees}
                            canClose={matterData.actions.canCloseMatter}
                            loggedInUser={state.loggedInUser}
                            defaultPriority={state.defaultPriority}
                            formAction={'create'}
                        />
                    )}
                    
                    {state.isTransferTrustToPayInvoiceOpen && (
                        <TransferTustToPayInvoiceDialog 
                            currencyDetails={currencyData}                 
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterTitle}
                            client={matterData.client}
                            onDialogClose={onDialogClose}
                            outstandingDebtors={outstandingDebtors}
                            currentTrustBalance={currentTrustBalance}
                            loggedInUser={state.loggedInUser}
                            defaultPriority={state.defaultPriority}
                            formAction={'create'}
                        />
                    )}
                    
                    {state.isArchiveMatterOpen && (
                        <ArchiveMatterDialog 
                            currencyDetails={currencyData}            
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterTitle}
                            client={matterData.client}
                            onDialogClose={onDialogClose}
                            billedFees={billedFees}
                            closedDate={matterData.completionDate}
                            loggedInUser={state.loggedInUser}
                            defaultPriority={state.defaultPriority}
                            formAction={'create'}
                        />
                    )}
                    
                    {state.isCloseMatterOpen && (
                        <CloseMatterDialog 
                            currencyDetails={currencyData}
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterTitle}
                            client={matterData.client}
                            onDialogClose={onDialogClose}
                            billedFees={billedFees}
                            loggedInUser={state.loggedInUser}
                            defaultPriority={state.defaultPriority}
                            formAction={'create'}
                        />
                    )}   

                    {state.isCreateTaskOpen && (
                        <TasksSummaryFormDialog  
                            isOpen={state.isCreateTaskOpen}
                            onClose={onDialogClose}
                            guid={props.data ? props.data.taskGuidID : null}
                            isCreate={true}
                            matterFileNumber={matterData.fileNumber}
                            matterGuid={matterData.matterGuid}
                            matterTitle={matterData.title}
                            defaultPriority={state.defaultPriority}
                        />
                    )} 
                    {state.isUploadDocumentOpen && (
                        <UploadDocumentDialog 
                            onClose={onDialogClose}
                            matter={{
                                label: `${matterData.fileNumber} (${matterData.title})`,
                                value: matterData.matterGuid
                            }}
                        />
                    )}  
                    {state.isMatterFollowUpOpen && (
                        <MatterFollowUpDialog 
                            onClose={onDialogClose}
                            matterData={matterData}
                        />
                    )} 
                    {state.isPublishMatterOpen && (
                        <PublishMatterDialog 
                            onClose={onDialogClose}
                            matterId={matterId}
                            matterGuid={matterData.matterGuid}
                            client={matterData.client}
                            matterTitle={matterData.title}
                            fileNumber={matterData.fileNumber}
                        />
                    )}
                    {state.isSendEmailOpen && (
                        <MatterSendEmailDialog 
                            open={state.isSendEmailOpen}
                            onClose={onDialogClose}
                            maxWidth="md"
                            fullWidth={true}
                            entityGuid={matterData.matterGuid}
                        />
                    )}
                </React.Fragment>
            );
        } else {
            return null;
        }
    };

    const getLoader = () => {
        return (
            <div className={classes.loaderWrapper}>
                <RvLoader />
            </div>
        );
    };

    const getMenuItems = () => {
        if (matterData) {
            return (
                <React.Fragment>  
                    <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        role={undefined}
                        transition={true}
                        disablePortal={false}
                        style={{
                            marginLeft: '100px',
                            // Same fix as AppContent.tsx's header zIndex:1250 comment and
                            // matterDetails/menu/ActionMenu.tsx — this Popper had no explicit
                            // z-index, so it rendered below the header (1250) and the QuickView
                            // drawer (theme.zIndex.drawer, 1200) when docked. Above the header,
                            // still below theme.zIndex.modal (1300).
                            zIndex: 1260
                        }}
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin:
                                        placement === 'bottom'
                                            ? 'center top'
                                            : 'center bottom',
                                }}
                            >  
                                <React.Fragment>
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleClose}>
                                            <MenuList
                                                autoFocusItem={open}
                                                id="menu-list-grow"
                                                onKeyDown={handleListKeyDown}
                                            >
                                                {UserFeature.HasAccess(UserFeatureEnum.hasMatterEdit) && (
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.ImportanceLevel)}
                                                    >
                                                        <EditIcon fontSize="small" className={classes.icon} /> Edit
                                                    </MenuItem>
                                                )}
                                                {UserFeature.HasAccess(UserFeatureEnum.hasPublishMatter) && (
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.PublishMatter)}
                                                    >
                                                        <PublishOutlinedIcon fontSize="small" className={classes.icon} /> Publish Matter
                                                    </MenuItem>
                                                )}
                                                {UserFeature.HasAccess(UserFeatureEnum.hasHasSendMatterEmail) && (
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.SendEmail)}
                                                    >
                                                        <MailOutlineIcon fontSize="small" className={classes.icon} /> Email Client
                                                    </MenuItem>
                                                )}
                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasBillMatter) && 
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.BillMatter)}
                                                        disabled={!matterData.actions.canBillMatter}
                                                    >
                                                        {matterData.actions.hasBillMatterTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <AssignmentTurnedInOutlinedIcon fontSize="small" className={classes.icon} /> Bill the matter
                                                    </MenuItem>
                                                }

                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasWriteOffWIP) &&
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.WriteOffUnbilledFees)}
                                                        disabled={!matterData.actions.canWriteOffUnbilledFees}
                                                    >
                                                        {matterData.actions.hasWriteOffUnbilledFeesTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <AssignmentOutlinedIcon fontSize="small" className={classes.icon} /> Write off Wip
                                                    </MenuItem>
                                                }
                                                
                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasTransferMatterTrust) &&
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.TransferTrustToPayInvoice)}
                                                        disabled={!matterData.actions.canTransferTrustToPayInvoice}
                                                    >
                                                        {matterData.actions.hasTransferTrustToPayInvoiceTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <AccountBalanceWalletOutlinedIcon fontSize="small" className={classes.icon} /> Transfer Trust to Pay invoice
                                                    </MenuItem>  

                                                }

                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasWriteOffDebtors)  &&
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.WriteOffDebtors)}
                                                        disabled={!matterData.actions.canWriteOffDebtors}
                                                    >
                                                        {matterData.actions.hasWriteOffDebtorsTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <TollOutlinedIcon fontSize="small" className={classes.icon} /> Write off Debtors
                                                    </MenuItem>
                                                }

                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasCloseMatter) &&

                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.CloseMatter)}
                                                        disabled={!matterData.actions.canCloseMatter}
                                                    >
                                                        {matterData.actions.hasCloseMatterTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <CancelPresentationOutlinedIcon fontSize="small" className={classes.icon} /> Close Matter
                                                    </MenuItem>
                                                }                             
                                                
                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasArchiveMatter) &&
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.ArchiveMatter)}
                                                        disabled={!matterData.actions.canArchiveMatter}
                                                    >
                                                        {matterData.actions.hasArchiveMatterTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <ArchiveOutlinedIcon fontSize="small" className={classes.icon} /> Archive Matter
                                                    </MenuItem>
                                                }                                                                                  
                                                
                                                {/* Display View Matter if it is used in Summary View only */}
                                                {props.data && props.data.id && !props.hideViewMatter && (
                                                    <MenuItem
                                                        onClick={(event: React.MouseEvent<EventTarget>) => 
                                                            onMatterDetailOpen(event)
                                                        }
                                                    >
                                                        <VisibilityOutlinedIcon fontSize="small" className={classes.icon} /> View Matter
                                                    </MenuItem>
                                                )} 

                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasCreateTask) && UserFeature.HasAccess(UserFeatureEnum.hasAdHocTask) &&
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.CreateTask)}
                                                        disabled={false}
                                                    >
                                                        {matterData.actions.hasMatterTask && (
                                                            <DoneIcon
                                                                fontSize="small"
                                                                className={classes.doneIcon}
                                                            />
                                                        )}
                                                        <PlaylistAddOutlinedIcon fontSize="small" className={classes.icon} /> Create Adhoc Task
                                                    </MenuItem>
                                                }                                               
                                                
                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasFollowUpMatterTask) && 
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.MatterFollowUpAction)}
                                                    >
                                                        <LocationSearchingOutlinedIcon fontSize="small" className={classes.icon} /> Follow Up
                                                    </MenuItem>
                                                }

                                                {/* <MenuItem
                                                    onClick={(event) => onEmailPersonActing(event)}
                                                    disabled={false}
                                                    style={!UserFeature.HasAccess(UserFeatureEnum.hasMatterEmailPersonActing) 
                                                        ? {display: 'none'} 
                                                        : {display: 'block'}}
                                                >
                                                    Email Person Acting
                                                </MenuItem>  
                                                <MenuItem
                                                    onClick={(event) => onEmailPersonResponsible(event)}
                                                    disabled={false}
                                                    style={!UserFeature.HasAccess(UserFeatureEnum.hasMatterEmailPersonResponsible) 
                                                        ? {display: 'none'} 
                                                        : {display: 'block'}}
                                                >
                                                    Email Person Responsible
                                                </MenuItem>   */}
                                                {
                                                    UserFeature.HasAccess(UserFeatureEnum.hasUploadMatterDocument) && 
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.UploadDocument)}
                                                        disabled={false}
                                                    >
                                                        <PublishOutlinedIcon fontSize="small" className={classes.icon} /> Upload Document
                                                    </MenuItem> 
                                                }
                                                {UserFeature.HasAccess(UserFeatureEnum.hasMatterForecast) && (
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.MatterForecasts)}
                                                        disabled={false}
                                                    >
                                                        <CastOutlinedIcon fontSize="small" className={classes.icon} /> Matter Forecasts
                                                    </MenuItem> 
                                                )}
                                                
                                                {tenantQuery.data?.tenant.sourceSystem.toLowerCase() === 'smokeball' && tenantQuery.data.tenant.smokeballAccessUrl && UserFeature.HasAccess(UserFeatureEnum.hasViewPmsMatter) && (
                                                    <MenuItem
                                                        onClick={handleClickMenu(MatterTaskActionEnum.SmokeballViewMatter)}
                                                        disabled={false}
                                                    >
                                                        <Avatar 
                                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABdCAMAAABkSTMDAAAAn1BMVEUAAADtcyP/bivtdCPtcyPtcyPqcSrudSDtcyPsdCLtcyPtcyPudCPtdSPtcyPuciPtdCPtcyPsdCHucyPtcyPtcyPtdSTucyPtciPtcyPucyPtciPtcyPtcyPwdB/ucyPtcyPuciPtdCTwdSTtciPtcyPtcSPuciPtcSLucyPtcyPscyPudCPwcyTvciTtcyPtcyPvcyTtciPtcyPucyPjwkYcAAAANXRSTlMA/AT58RsMB/Uz6uZXQ8ZoUO4n3L6NONl9FeCwmlwR1Kp3Pi7MuXKGYQ60lUkpIdCggG6lkXBBbP4AAAW6SURBVGjerVjpmqowDG3ZBBVUFFdEx3Hft/d/tnvvGCItbWnnen7N1H6cJk1OkhIz1ML7YX9p1P+iMYv2h3U7tshH4TXnDi3BiTaLjxHtbnUqQ+d6/AVPbRNzK9MGVaKx9gw5+pc5u2ClFKCiqRlQWDebfrOGTagOulNtp7kRpRG7dKWaiE6arvrn/C2ztKWI+mMduplFSObGQfsrjepcrN11jJn6lFI7Y+IKP7QKy584bx9MYPdGlRxfr43cGgRqWxbdrUHxZr6JGsPXvg2zOAAOhb+t5qzgsqYOB2V2jZhFKU3rnUj2lsjRogDG4NNrbWBVqc7zzTIlMjRpDpcJt9daSiqxGFSyfHeQZFdcD19rN1KNbEUB/kK8oUsRHnO+19pBSyw2mFAxEWBPqdhdwWttSbQwpICLJ7t0wInJNowGLdwoICnnLZO1bcYFDpiiKbK5x+w+4cDK7BcpYg6rE09PxPNvzbhTtSmDCRuZqLGuXpm+CM9aywP8Cgpi8abAupbGksCG7YxW3uEj81xCQlLEaExzLI8m13Io2teA2HbJBSzijtahiEhBw3vGPpcNWWOYOxknGMXatJxK44y/4+c7HCDXuzVUQzrkNWdACxgPqypTDw474mmnhV87GR8yB1qE/wgt5d3zh92DIRYwSvI17HK9yZdbbcogT3YbbuTlu5koX6EujVkae9WUmhPCngVTwp0dW1VmniDNhhhmeDsycwZMGYrgP85QOhGdcnfvcjT2PFDJcd36yTSby7/ARlUQIiy1k0tR5+jaBX9NoZO1SvlKt7IaeuC9dhF0S1GhoqalHK8tK7sOr7XkaHqBxF9R4YKmxeLSwMIjT4Z+yppjX11hqvg1QjJRxT3aFJAqFMSb9lR9sAVSFGCxGMuKcXQmCpwTh7kaxmfQurTwc5NyTwxwtkSFETPl+UOLEXzQ+0TSVd0pYnVSD5PDIs0q45vFPVa9rXCGAPhJpqbZ+KKmvg/SgdEciqchpDmoy7t7FTT1LvxPCKiEqN+Ll8XQOXyr++BZqam3wD6LwHGFB6092YFw66lK7s1GltZrqZ6TQEaB0ytqSEdpzuJdCV4s45wETJLlnJfYlMEqVITzHm350bIZfDsnkTviu8eP0YFGu+3334pVy92lCp4w4ipIKm8jML3GLroLL16db+GepWm0q0fCnoUXn/utT9SIN2x9v0r9u8bLt+A6sdhWt4XWcW4XtTCu6lGdEAowIY/XX3eiATcplJC6zHhrlQsMFGfkTYkWsufbGuco28R6do4lPiKaiFdvQWurZ3VAgkXSsXRZrJaPLLLEhH4GC3vNzxVSG0FXOkcDYvgofjnKm1R9jNBlgx0RIqUAmNoSyB1iAOtBAQ+JKQWx++lMQCsycxbwuOrpAVzk+cxLkylLY6QatVCw9rlZRsA2MxX/7FBmQJnis4YR3Ab4OVBGcQK9hl/5DKT0yFylxnj0FIdIM8ypIsUCTkn6OESa4QQ6thFeis/1c0swxTVkOUARFErS5Sf2aiXvPkxNoYqKN+F15IK7zXBRzH3Pf4Z4xXmEGr2b8b3/RNy48Ow9fAsxQh8STnIAeFUrTbxtI5Id1BVJovDlJskrxNmIBc4mJtnzS143v5adiUxSOcm67pYzNC9mkadP4uUTiAC3tuo9d2LpiyTIvbCHVrZL9KrNEuQDmzayAdqi67FtrsP6iHGKXWqq2DMfnQ3Qd7DxD4gOur+p3CGy2Kqpmn/6PhNjFkBjW3n/E9N7BwQNiphVuKGJj2+mOBVb8p5C+/HByneJMUY9WqQ5Sm0ev3sic1jsVD1bu6KjpLAJirY5Tit22t23YrZJOF7fAXInv0W7S1mM90mrvQiCsPmVRh1mjvo9akOH6qDnkf+BmyhoZCpnjlHSUVP4a/IBeK2ZylUx+RAWyUBsxXxBPonv9ZwLtsG1uSOfhxcH4bH5D+3+2fS2/wAxZVcsE0aM2QAAAABJRU5ErkJggg=="
                                                            style={{
                                                                width: '1em',
                                                                height: '1em',
                                                                verticalAlign: 'middle'
                                                            }}
                                                            className={classes.icon}
                                                        
                                                        /> View {tenantQuery.data?.tenant.sourceSystem} Matter
                                                    </MenuItem> 
                                                )}
                                                
                                            </MenuList>
                                        </ClickAwayListener>                                                    
                                    </Paper>
                                </React.Fragment>                        
                            </Grow>
                        )}
                    </Popper>
                </React.Fragment> 
            );
        } else {
            return null;
        }
    };

    return (
        <React.Fragment>
            {
                props.data !== undefined && (
                    <div className={classes.root + ' ag-matter-action-column'}>
                        <Tooltip title="More actions">
                            <IconButton
                                color="primary"
                                ref={anchorRef}
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}
                            >
                                <MoreHorizOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        {
                            isLoading || tenantQuery.loading
                            ? getLoader()
                            : getMenuItems()                  
                        }

                        {getMatterTaskActions(matterId)} 
                    </div> 
                )
            }
        </React.Fragment>    
    );
};
